import { render, staticRenderFns } from "./ToggleComponent.vue?vue&type=template&id=0067c485"
import script from "./ToggleComponent.vue?vue&type=script&lang=js"
export * from "./ToggleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports